export const userAccessCopy = {
  ar: {
    title: "المستخدمون والصلاحيات",
    description: "اختر مستخدمًا لإدارة دوره والمؤتمرات المتاحة له.",
    refresh: "تحديث القائمة",
    refreshing: "جارٍ التحديث…",
    choose: "المستخدمون",
    role: "الدور",
    viewer: "مستخدم — عرض فقط",
    viewerShort: "مستخدم",
    admin: "مسؤول النظام",
    permissions: "إعدادات الوصول",
    active: "نشط",
    pending: "بانتظار الإعداد",
    disabled: "معطّل",
    mfaReady: "التحقق بخطوتين مفعّل",
    mfaPending: "لم يكتمل التحقق بخطوتين",
    scope: "الوصول إلى المؤتمرات",
    all: "كل المؤتمرات",
    selected: "مؤتمرات محددة",
    allShort: "المحفظة كاملة",
    selectedShort: "اختر المؤتمرات المسموحة",
    allHelp: "يشمل المؤتمرات الحالية وأي مؤتمر يُضاف لاحقًا.",
    selectedHelp:
      "تظهر للمستخدم المؤتمرات المختارة فقط، وتُحسب منها النظرة العامة. ترك الاختيار فارغًا يمنع الوصول إلى بيانات المؤتمرات.",
    adminHelp:
      "يصل مسؤول النظام إلى كل المؤتمرات، ويدير الإيرادات والمستخدمين وربط المؤتمرات.",
    confirm: "أؤكد منح هذا المستخدم صلاحيات مسؤول النظام كاملة",
    pendingPromotion:
      "يلزم حساب نشط مع تحقق بخطوتين مكتمل للترقية إلى مسؤول النظام.",
    protected:
      "هذا الحساب محمي. لا يمكنك تغيير صلاحيات حسابك الحالي أو الحساب الرئيسي أو حذف أي منهما من هنا.",
    save: "حفظ الصلاحيات",
    saving: "جارٍ الحفظ…",
    saved: "تم حفظ الصلاحيات. يُطبق الوصول الجديد على طلبات البيانات التالية.",
    failed:
      "تعذر حفظ الصلاحيات. حدّث القائمة ثم أعد المحاولة؛ ربما عدّل مسؤول آخر هذا الحساب.",
    loadFailed: "تعذر تحميل المستخدمين. حاول تحديث القائمة.",
    empty: "لا يوجد مستخدمون. أضف مستخدمًا من قسم إعداد الحسابات أدناه.",
    loading: "جارٍ تحميل المستخدمين…",
    noConferences: "لم يُربط أي مؤتمر بعد.",
    search: "اختيار المؤتمرات",
    searchPlaceholder: "ابحث عن مؤتمر…",
    noMatches: "لا توجد مؤتمرات تطابق البحث.",
    userSearch: "ابحث بالبريد الإلكتروني…",
    noUsersMatch: "لا يوجد مستخدم يطابق البحث.",
    selectedCount: "محدد",
    unsaved: "تغييرات غير محفوظة",
    discard: "لديك تغييرات غير محفوظة. هل تريد تجاهلها؟",
    cancel: "إلغاء",
    deleteUser: "حذف المستخدم",
    deleteHelp: "إزالة الحساب وصلاحياته نهائيًا من هذه المنصة.",
    deleteTitle: "حذف هذا المستخدم نهائيًا؟",
    permanent: "إجراء لا يمكن التراجع عنه",
    deleteDescription:
      "سيُحذف حساب الدخول وكلمة المرور وإعداد التحقق بخطوتين وكل الأدوار وصلاحيات المؤتمرات. عند إضافته لاحقًا يبدأ كمستخدم جديد ويُعدّ المصادقة من البداية.",
    deleteAudit:
      "لا تُحذف بيانات المؤتمرات أو السجلات المالية. يُحتفظ بسجل التدقيق الإداري دون منحه أي صلاحية دخول.",
    deleteConfirm: "أفهم أن الحذف نهائي وأؤكد حذف هذا المستخدم",
    deletePermanently: "حذف نهائي",
    deleting: "جارٍ حذف المستخدم…",
    deleted:
      "تم حذف المستخدم وحسابه وصلاحياته. أي إضافة لاحقة تبدأ بإعداد جديد.",
    deleteFailed:
      "لم يكتمل الحذف. قد يكون الوصول قد أُوقف بالفعل؛ أعد المحاولة لإكمال إزالة الحساب، أو أغلق هذه النافذة وحدّث القائمة.",
    deleteConflict:
      "تغيّرت حالة الحساب. أغلق النافذة وحدّث القائمة قبل إعادة المحاولة.",
    retryDelete: "إكمال الحذف",
    deletionPending: "مستخدم قيد الحذف",
    deletionPendingHelp:
      "أُوقف وصول هذا الحساب، لكن لم تكتمل إزالته. استخدم «إكمال الحذف» أدناه.",
  },
  en: {
    title: "Users and permissions",
    description: "Select a user to manage their role and conference access.",
    refresh: "Refresh list",
    refreshing: "Refreshing…",
    choose: "Users",
    role: "Role",
    viewer: "User — read only",
    viewerShort: "User",
    admin: "System administrator",
    permissions: "Access settings",
    active: "Active",
    pending: "Setup pending",
    disabled: "Disabled",
    mfaReady: "Two-step verification enabled",
    mfaPending: "Two-step verification incomplete",
    scope: "Conference access",
    all: "All conferences",
    selected: "Selected conferences",
    allShort: "The full portfolio",
    selectedShort: "Choose permitted conferences",
    allHelp:
      "Includes current conferences and conferences added in the future.",
    selectedHelp:
      "Only selected conferences appear, and overview totals include only these conferences. Selecting none gives this user no conference data.",
    adminHelp:
      "System administrators access all conferences and manage revenue, users and conference connections.",
    confirm:
      "I confirm granting this user full system administrator permissions",
    pendingPromotion:
      "Promotion requires an active account with two-step verification completed.",
    protected:
      "This account is protected. You cannot change permissions or delete your current account or the primary account here.",
    save: "Save permissions",
    saving: "Saving…",
    saved: "Permissions saved. Subsequent data requests use the new access.",
    failed:
      "Permissions could not be saved. Refresh and retry; another administrator may have changed the account.",
    loadFailed: "Could not load users. Try refreshing the list.",
    empty: "No users yet. Add a user in account setup below.",
    loading: "Loading users…",
    noConferences: "No conferences have been connected yet.",
    search: "Choose conferences",
    searchPlaceholder: "Find a conference…",
    noMatches: "No conferences match your search.",
    userSearch: "Search by email…",
    noUsersMatch: "No users match your search.",
    selectedCount: "selected",
    unsaved: "Unsaved changes",
    discard: "You have unsaved changes. Discard them?",
    cancel: "Cancel",
    deleteUser: "Delete user",
    deleteHelp: "Permanently remove this account and its platform access.",
    deleteTitle: "Permanently delete this user?",
    permanent: "This cannot be undone",
    deleteDescription:
      "Their sign-in account, password, two-step verification, roles and conference permissions will be removed. Adding them again creates a new user who must set up authentication from the beginning.",
    deleteAudit:
      "Conference data and financial records remain unchanged. Administrative audit history is retained without granting any sign-in access.",
    deleteConfirm:
      "I understand this is permanent and confirm deleting this user",
    deletePermanently: "Delete permanently",
    deleting: "Deleting user…",
    deleted:
      "The user, sign-in account and permissions were deleted. Adding them later starts a new setup.",
    deleteFailed:
      "Deletion did not finish. Access may already be blocked; retry to finish removing the account, or close this dialog and refresh the list.",
    deleteConflict:
      "The account state changed. Close this dialog and refresh the list before retrying.",
    retryDelete: "Finish deletion",
    deletionPending: "User deletion pending",
    deletionPendingHelp:
      "Access is blocked, but removal is incomplete. Use “Finish deletion” below.",
  },
};
